import { useSelector } from "react-redux"
import { getTranslated } from "../../utils/CommonUtils"

const UMCAttrTextView = (props) => {

    const dict = useSelector(state => state.common.dict)

    return <div className="attr-block">
        <span className="attr-label">{getTranslated(dict, props.label)}: </span>
        <span className="attr-value"><b>{props.value}</b></span>
    </div>
}

export default UMCAttrTextView